var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13672 3.89014V1.83936",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8086 3.89014V1.83936",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98438 10.7261H27.9609",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30078 14.8276C1.30078 9.67164 1.30078 7.09366 2.90254 5.49189C4.50431 3.89014 7.08229 3.89014 12.2383 3.89014H17.707C22.863 3.89014 25.4411 3.89014 27.0427 5.49189C28.6445 7.09366 28.6445 9.67164 28.6445 14.8276V17.562C28.6445 22.7179 28.6445 25.2961 27.0427 26.8977C25.4411 28.4995 22.863 28.4995 17.707 28.4995H12.2383C7.08229 28.4995 4.50431 28.4995 2.90254 26.8977C1.30078 25.2961 1.30078 22.7179 1.30078 17.562V14.8276Z",
    stroke: "#005350",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1758 21.6636C23.1758 22.4187 22.5637 23.0308 21.8086 23.0308C21.0535 23.0308 20.4414 22.4187 20.4414 21.6636C20.4414 20.9085 21.0535 20.2964 21.8086 20.2964C22.5637 20.2964 23.1758 20.9085 23.1758 21.6636Z",
    fill: "#005350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1758 16.1948C23.1758 16.9499 22.5637 17.562 21.8086 17.562C21.0535 17.562 20.4414 16.9499 20.4414 16.1948C20.4414 15.4397 21.0535 14.8276 21.8086 14.8276C22.5637 14.8276 23.1758 15.4397 23.1758 16.1948Z",
    fill: "#005350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 21.6636C16.3398 22.4187 15.7278 23.0308 14.9727 23.0308C14.2176 23.0308 13.6055 22.4187 13.6055 21.6636C13.6055 20.9085 14.2176 20.2964 14.9727 20.2964C15.7278 20.2964 16.3398 20.9085 16.3398 21.6636Z",
    fill: "#005350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3398 16.1948C16.3398 16.9499 15.7278 17.562 14.9727 17.562C14.2176 17.562 13.6055 16.9499 13.6055 16.1948C13.6055 15.4397 14.2176 14.8276 14.9727 14.8276C15.7278 14.8276 16.3398 15.4397 16.3398 16.1948Z",
    fill: "#005350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50391 21.6636C9.50391 22.4187 8.89179 23.0308 8.13672 23.0308C7.38165 23.0308 6.76953 22.4187 6.76953 21.6636C6.76953 20.9085 7.38165 20.2964 8.13672 20.2964C8.89179 20.2964 9.50391 20.9085 9.50391 21.6636Z",
    fill: "#005350"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50391 16.1948C9.50391 16.9499 8.89179 17.562 8.13672 17.562C7.38165 17.562 6.76953 16.9499 6.76953 16.1948C6.76953 15.4397 7.38165 14.8276 8.13672 14.8276C8.89179 14.8276 9.50391 15.4397 9.50391 16.1948Z",
    fill: "#005350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8cdd596cd313170ceab4a93172317c22.svg";
export { ForwardRef as ReactComponent };